<template>
    <div style="margin-top: -5px;font-size: 16px;">
        <div style="width: 96%;height:100%;margin: 0px auto;">
            <div class="determ">
                <div style="font-size: 12px;width: 98%;margin: 0px auto;height: 90%;overflow-y: auto;">
                    <div>
                        <el-table v-show="!quick" :data="lossDeterm.partsList">
      <el-table-column label="定损部件" prop="name">
      </el-table-column>
      <el-table-column align="center" label="拆检" width="40">
        <template #default="{ row }">
          <i class="el-icon-check" v-if="row.isDisassembly"></i>
        </template>
      </el-table-column>
      <el-table-column align="center" label="钣金" width="40">
        <template #default="{ row }">
          <i class="el-icon-check" v-if="row.isSheetMetal"></i>
        </template>
      </el-table-column>
      <el-table-column align="center" label="喷漆" width="40">
        <template #default="{ row }">
          <i class="el-icon-check" v-if="row.isPaint"></i>
        </template>
      </el-table-column>
      <el-table-column align="center" label="工时" prop="sheetMetalWH" width="40">
        <template #default="{ row }">
          {{(row.isSheetMetal || row.isDisassembly) ? row.sheetMetalWH + row.disassemblyWH + row.assemblyWH : ''}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="幅数" prop="paintArea" width="40">
        <template #default="{ row }">
          {{row.isPaint ? row.paintArea : ''}}
        </template>
      </el-table-column>
      <el-table-column width="20" align="center">
        <template #default="{ $index, row }">
          <el-button :disabled="row.fixed" @click="deleteParts($index)" icon="el-icon-delete-solid"
                     type="text"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table v-show="quick" :data="lossDeterm.partsList">
      <el-table-column label="定损部件" prop="name">
      </el-table-column>
      <el-table-column align="center" label="油漆幅数" prop="paintArea" width="60">
        <template #default="{ row }">
          {{row.isPaint ? row.paintArea : ''}}
        </template>
      </el-table-column>
      <el-table-column width="20" align="center">
        <template #default="{ $index, row }">
          <el-button :disabled="row.fixed" @click="deleteParts($index)" icon="el-icon-delete-solid"
                     type="text"></el-button>
        </template>
      </el-table-column>
    </el-table>
                    </div>
                </div>
                <div style="width: 100%;border-top: 1px solid black;display: flex;justify-content: space-around;">
                    <div class="btnAddpro" @click="showDialog=!showDialog">选择项目</div>
                    <!-- <div class="btnRevise">修改项目</div> -->
                </div>
            </div>
            <div class="total">
                <div style="display:flex;justify-content: space-around;margin-top:10px;">
                    <div style="display:flex;">
                        <div style="width:80px;">维修板件：</div>
                        <div style="width:30px;">{{lossDeterm.sheetMetalPiece}}</div>
                    </div>
                    <div style="display:flex;">
                        <div style="width:80px;">钣金工时：</div>
                        <div style="width:30px;">{{sheetMetalWH.toFixed(2)}}</div>
                    </div>
                    <div style="display:flex;">
                        <div style="width:80px;">油漆幅数：</div>
                        <div style="width:30px;">{{lossDeterm.paintArea.toFixed(2)}}</div>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="showDialog" style="width: 100%; height: 100%">
            <wx-loss-determ-dialog :visible.sync="showDialog" :selected-parts-list="lossDeterm.partsList||[]"
            :work="work"
            @update:selectedPartsList="updatePartList($event)"
            :repair-type="lossDeterm.repairType"></wx-loss-determ-dialog>
        </van-popup>
    </div>
  </template>

  <script>
    import WxLossDetermDialog from '@/views/wx/work-add/WxLossDetermDialog'
    import { Popup } from 'vant'
    import { shareDataMixin } from '@/views/mixins/ShareData'

    export default {
      name: 'WxLossDetermPanel',
      mixins: [shareDataMixin],
      components: {
        WxLossDetermDialog,
        [Popup.name]: Popup
      },
      props: {
        work: {
          type: Object,
          required: true
        },
        lossDeterm: {
            required: true
        }
      },
      data () {
        return {
            showDialog: false
        }
      },
      created () {

      },
      methods: {
        deleteParts (index) {
            this.lossDeterm.partsList.splice(index, 1)
            this.updateWH()
            this.updatePrice()
        },
        updatePartList ({ repairType, partsList }) {
            this.lossDeterm.repairType = repairType
            this.lossDeterm.partsList = partsList
            this.updateWH()
            this.updatePrice()
        },
        updateWH () {
        let disassemblyWH = 0
        let sheetMetalWH = 0
        let assemblyWH = 0
        let paintWH = 0
        let paintArea = 0
        let sheetMetalPiece = 0

        for (const parts of this.lossDeterm.partsList) {
          if (!this.quick) {
            disassemblyWH += parts.disassemblyWH
            sheetMetalWH += parts.sheetMetalWH
            assemblyWH += parts.assemblyWH
            sheetMetalPiece += (parts.isDisassembly || parts.isSheetMetal) ? 1 : 0
          }
          paintArea = this.tosalAdd(paintArea, parts.paintArea)
          paintWH += this.tosalMul(parts.paintArea, this.work.basicPaintWorkHour)
        }
        this.lossDeterm.sheetMetalPiece = sheetMetalPiece
        this.lossDeterm.disassemblyWH = disassemblyWH
        this.lossDeterm.sheetMetalWH = sheetMetalWH
        this.lossDeterm.assemblyWH = assemblyWH
        this.lossDeterm.paintArea = paintArea
        this.lossDeterm.paintWH = paintWH
      },
      updatePrice () {
        let sumPrice = 0
        if (this.quick) {
          for (const parts of this.lossDeterm.partsList) {
            sumPrice += this.partsCoeMap[parts.id].quickCoe[1]
          }
        } else {
          for (var parts of this.lossDeterm.partsList) {
            if (parts.isDisassembly) {
              sumPrice += this.partsCoeMap[parts.id].disassemblyCoe[1]
            }
            if (parts.isSheetMetal) {
              sumPrice += this.partsCoeMap[parts.id].sheetMetalCoe[parts.sheetMetalDegree][1]
              sumPrice += this.partsCoeMap[parts.id].assemblyCoe[1]
            }
            if (parts.isPaint) {
              sumPrice += this.partsCoeMap[parts.id].paintCoe[parts.paintDegree][1]
            }
          }
        }
        this.lossDeterm.cost = sumPrice.toFixed(2)
      },
      tosalAdd (arg1, arg2) { // 精准加法
        var r1, r2, m
        try {
          r1 = arg1.toString().split('.')[2].length
        } catch (e) {
          r1 = 0
        }
        try {
          r2 = arg2.toString().split('.')[2].length
        } catch (e) {
          r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        return (arg1 * m + arg2 * m) / m
      },
      tosalMul (arg1, arg2) { // 精准乘法
        var m = 0
        var s1 = arg1.toString()
        var s2 = arg2.toString()
        try {
            m += s1.split('.')[2].length
        } catch (e) {}
        try {
            m += s2.split('.')[2].length
        } catch (e) {}

        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
      }
      },
      computed: {
        quick () {
            return this.lossDeterm.repairType === 'QUICK'
        },
        sheetMetalWH () {
            return this.lossDeterm.disassemblyWH * 1 + this.lossDeterm.sheetMetalWH * 1 + this.lossDeterm.assemblyWH * 1
        }
      }
    }
  </script>

  <style lang="scss" scoped>
        // .titlePro{
        //     display: flex;
        //     text-align: center;border: 1px solid #5F6A93;
        //     border-radius: 10px;
        //     background-color: #5F6A93;
        //     color: white;
        //     height: 25px;
        //     line-height: 25px;
        // }
        .determ{
            width: 100%;
            border: 1px solid white;
            border-radius: 10px;
            min-height: 400px;
            height: 90%;
            margin-top: 10px;
            background-color: white;
        }
        .btnAddpro{
            width: 150px;
            height: 30px;
            line-height: 30px;
            color: white;
            border: 1px solid #329DFF;
            border-radius: 10px;
            background-color: #329DFF;
            text-align: center;
            margin-top: 5px;
        }
        .btnRevise{
            width: 150px;
            height: 30px;
            line-height: 30px;
            color: white;
            border: 1px solid #329DFF;
            border-radius: 10px;
            background-color: #329DFF;
            text-align: center;
            margin-top: 5px;
        }
        .total{
            width: 100%;
            border: 1px solid white;
            border-radius: 10px;
            height: 40px;
            margin-top: 10px;
            background-color: white;
        }
        /deep/ .el-table th.el-table__cell > .cell{
            padding-left: 0px;
            padding-right: 0px;
        }
        /deep/ .cell{
            padding-left: 0px;
            padding-right: 0px;
        }
  </style>
